export var FETCH_SUBSCRIPTION_LOADING = 'FETCH_SUBSCRIPTION_LOADING';
export var FETCH_SUBSCRIPTION_SUCCESS = 'FETCH_SUBSCRIPTION_SUCCESS';
export var FETCH_SUBSCRIPTION_ERROR = 'FETCH_SUBSCRIPTION_ERROR';
export var FETCH_PRODUCTS_LOADING = 'FETCH_PRODUCTS_LOADING';
export var FETCH_PRODUCTS_SUCCESS = 'FETCH_PRODUCTS_SUCCESS';
export var FETCH_PRODUCTS_ERROR = 'FETCH_PRODUCTS_ERROR';
export var FETCH_LEGAL_CALENDAR_LOADING = 'FETCH_LEGAL_CALENDAR_LOADING';
export var FETCH_LEGAL_CALENDAR_SUCCESS = 'FETCH_LEGAL_CALENDAR_SUCCESS';
export var FETCH_LEGAL_CALENDAR_ERROR = 'FETCH_LEGAL_CALENDAR_ERROR';
export var FETCH_PAYMENT_DEFAULT_METHOD_LOADING = 'FETCH_PAYMENT_DEFAULT_METHOD_LOADING';
export var FETCH_PAYMENT_DEFAULT_METHOD_SUCCESS = 'FETCH_PAYMENT_DEFAULT_METHOD_SUCCESS';
export var FETCH_PAYMENT_DEFAULT_METHOD_FAIL = 'FETCH_PAYMENT_DEFAULT_METHOD_FAIL';
export var UPDATE_SUBSCRIPTION_LOADING = 'UPDATE_SUBSCRIPTION_LOADING';
export var UPDATE_SUBSCRIPTION_SUCCESS = 'UPDATE_SUBSCRIPTION_SUCCESS';
export var UPDATE_SUBSCRIPTION_ERROR = 'UPDATE_SUBSCRIPTION_ERROR';
export var CANCEL_SUBSCRIPTION_SUCCESS = 'CANCEL_SUBSCRIPTION_SUCCESS';
